var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrid07(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 124,
    viewBox: "0 0 178 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 178,
    height: 124,
    fill: "white",
    fillOpacity: 0.12
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.0518,
    y: 20.2979,
    width: 39.0351,
    height: 23.4211,
    rx: 3.12281,
    fill: "#616161"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 93.6841,
    y: 20.2979,
    width: 39.0351,
    height: 23.4211,
    rx: 3.12281,
    fill: "#616161"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 14.0518,
    y: 46.842,
    width: 39.0351,
    height: 23.4211,
    rx: 3.12281,
    fill: "#616161"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 93.6841,
    y: 46.842,
    width: 39.0351,
    height: 23.4211,
    rx: 3.12281,
    fill: "#616161"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 14.0518,
    y: 73.386,
    width: 39.0351,
    height: 21.8596,
    rx: 3.12281,
    fill: "#616161"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 93.6841,
    y: 73.386,
    width: 39.0351,
    height: 21.8596,
    rx: 3.12281,
    fill: "#616161"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0518 101.491C14.0518 99.766 15.4499 98.3679 17.1746 98.3679H49.964C51.6887 98.3679 53.0868 99.766 53.0868 101.491V104.614H14.0518V101.491Z",
    fill: "#616161"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6841 101.491C93.6841 99.766 95.0822 98.3679 96.8069 98.3679H129.596C131.321 98.3679 132.719 99.766 132.719 101.491V104.614H93.6841V101.491Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid07);
export default __webpack_public_path__ + "static/media/grid_07.653eea4abfc8c2f701b54ade1c9b996d.svg";
export { ForwardRef as ReactComponent };